export default __webpack_public_path__ + "static/media/btm_arrw_wins.12a9291b.svg";